__webpack_require__.p = "/docboard/";